<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import AgentConversationList from '../components/AgentConversationList.vue';

const store = useStore();

onMounted(() => {
  store.dispatch('agentConversations/fetch');
});
</script>

<template>
  <section class="flex w-full h-full min-w-0">
    <AgentConversationList />
    <div
      class="flex flex-col min-w-0 w-full bg-n-surface-1 relative border-l rtl:border-l-0 rtl:border-r border-n-weak"
    >
      <router-view />
    </div>
  </section>
</template>
